<nz-tabset nzCentered (nzSelectChange)="resetTable()">
    <nz-tab nzTitle="Open">
        <ng-template nz-tab>
            <nz-table #available [nzData]="tableData" [nzFrontPagination]="false" [nzLoading]="isLoading">
                <thead>
                    <tr>
                        <th></th>
                        <th>Brand</th>
                        <th>Description</th>
                        <th>Units</th>
                        <th>Available SOH</th>
                        <th>Jobcard Number / <br> SF Reference</th>
                        <th>Salesman</th>
                        <th>Date</th>
                        <th>Vehicle Details</th>
                        <th>Comments</th>
                        <th>Quantity</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    <ng-container *ngFor="let data of available.data | filter: '': []: 0: pageSize">
                        <!-- <tr *ngFor="let item of available.data | filter: '': []: 0: pageSize"> -->
                        <tr class="parent-row" [class.quote-row]="data.quoteId !== 0"
                            [class.order-row]="data.orderId !== 0" *ngFor="let item of data.parentItems"
                            [ngStyle]="{'color':(item.orderId === 0 && item.quoteId === 0) ? 'var(--textcolor)': ''}">
                            <td>
                                <button *ngIf="hasChildren(data)" nz-button nzType="default" nzSize="small"
                                    (click)="toggleExpand(data)">
                                    <span nz-icon [nzType]="data.expand ? 'minus' : 'plus'"></span>
                                </button>
                            </td>
                            <td><img src="https://sftptyres.blob.core.windows.net/brands-images/brands/{{item.brandImage}}"
                                    class="brandImage" alt="{{item.brand}}" nz-tooltip nzTooltipTitle="{{item.brand}}"
                                    nzTooltipPlacement="right" /></td>
                            <td>{{item.description}}</td>
                            <td>{{item.qty}}</td>
                            <td>{{calculateRealSOH(item)}}
                                <i nz-icon *ngIf="auth.user.client_id !== item.SOH_SellerId" nzType="info-circle"
                                    class=" color-primary" style="margin-left:10px" nz-tooltip
                                    [nzTooltipTitle]="sohTemplate"></i>
                                <ng-template #sohTemplate let-thing>
                                    <span> Ordered from: </span><span
                                        class="color-primary">{{item.SOH_ClientName}}</span>
                                </ng-template>
                            </td>
                            <td>{{item.jobCardNumber}} <br> {{item.SFReference}}</td>
                            <td>{{item.assignedTo}}</td>
                            <td [style.color]="getDateColor(item.dt)">{{item.dt + 'Z' | date:'dd MMM YYYY HH:mm'}}</td>
                            <td class="text-center">
                                <button nz-button (click)="selectItem(item)"><span nz-icon nzType="eye"
                                        nzTheme="outline"></span></button>
                            </td>
                            <td>
                                <input type="text" nz-input placeholder="Add any comments" [(ngModel)]="item.comments"
                                    *ngIf="!(item.orderId === 0 && item.quoteId === 0)" />
                            </td>
                            <td>
                                <nz-input-number [(ngModel)]="item.pickedQty" nzSize="small" [nzMin]="1"
                                    [nzMax]="item.qty" *ngIf="!(item.orderId === 0 && item.quoteId === 0)" />
                            </td>
                            <td>
                                <button nzType="primary" nz-button [nz-tooltip]="pickedTemplate"
                                    (click)="updateStockPicked(item)" [disabled]="!item.isPickable"
                                    *ngIf="!(item.orderId === 0 && item.quoteId === 0)">
                                    <span nz-icon nzType="select" nzTheme="outline"></span>
                                    Pick Stock
                                </button>
                                <ng-template #pickedTemplate let-thing>
                                    <span *ngIf="!item.isPickable"> Picking of this stock has been delayed by the
                                        salesman <br>(<strong>{{item.assignedTo}}</strong>). </span>
                                    <span *ngIf="item.isPickable"> Click to pick stock for this item. </span>
                                </ng-template>
                            </td>
                        </tr>
                        <!-- Child Rows (Non-Tyre Items) -->
                        <ng-container
                            *ngIf="(data.expand && data.childItems) || (data.parentItems.length === 0 && data.childItems)"
                            class="child-row-container">
                            <tr class="child-data-row" *ngFor="let child of data.childItems" class="color-primary">
                                <td>
                                    <span nz-icon nzType="double-right" nzTheme="outline"></span>
                                </td>
                                <td><img src="https://sftptyres.blob.core.windows.net/brands-images/brands/{{child.brandImage}}"
                                        class="brandImage" alt="{{child.brand}}" nz-tooltip
                                        nzTooltipTitle="{{child.brand}}" nzTooltipPlacement="right" /></td>
                                <td>{{child.description}}</td>
                                <td>{{child.qty}}</td>
                                <td>{{calculateRealSOH(child)}}
                                    <i nz-icon *ngIf="auth.user.client_id !== child.SOH_SellerId" nzType="info-circle"
                                        class=" color-primary" style="margin-left:10px" nz-tooltip
                                        [nzTooltipTitle]="sohTemplate"></i>
                                    <ng-template #sohTemplate let-thing>
                                        <span> Ordered from: </span><span
                                            class="color-primary">{{child.SOH_ClientName}}</span>
                                    </ng-template>
                                </td>
                                <td>{{child.jobCardNumber}} <br> {{child.SFReference}}</td>
                                <td>{{child.assignedTo}}</td>
                                <td>{{child.dt + 'Z' | date:'dd MMM YYYY HH:mm'}}</td>
                                <td class="text-center">
                                    <button nz-button (click)="selectItem(child)"><span nz-icon nzType="eye"
                                            nzTheme="outline"></span></button>
                                </td>
                                <td>
                                    <input type="text" nz-input placeholder="Add any comments"
                                        [(ngModel)]="child.comments" />
                                </td>
                                <td>
                                    <nz-input-number [(ngModel)]="child.pickedQty" nzSize="small" [nzMin]="1"
                                        [nzMax]="child.qty" />
                                </td>
                                <td>
                                    <button nzType="primary" nz-button [nz-tooltip]="pickedTemplate"
                                        (click)="updateStockPicked(child)" [disabled]="!child.isPickable">
                                        <span nz-icon nzType="select" nzTheme="outline"></span>
                                        Pick Stock
                                    </button>
                                    <ng-template #pickedTemplate let-thing>
                                        <span *ngIf="!child.isPickable"> Picking of this stock has been delayed by the
                                            salesman <br>(<strong>{{child.assignedTo}}</strong>). </span>
                                        <span *ngIf="child.isPickable"> Click to pick stock for this item. </span>
                                    </ng-template>
                                </td>
                            </tr>
                        </ng-container>
                    </ng-container>

                </tbody>
            </nz-table>
        </ng-template>
    </nz-tab>
    <nz-tab nzTitle="Picked">
        <ng-template nz-tab>
            <div nz-row>
                <div nz-col nzSpan="8" class="text-center"></div>
                <div nz-col nzSpan="8" class="text-center">
                    <span class="text-muted">Filter by Date: </span>
                    <nz-space>
                        <nz-range-picker *nzSpaceItem [(ngModel)]="dateSelect" class="text-center"></nz-range-picker>
                        <button nz-button *nzSpaceItem nzType="primary"
                            (click)="filterCompletedStockPicked(dateSelect)">
                            <i nz-icon nzType="filter" nzTheme="outline"></i>Filter
                        </button>
                    </nz-space>
                    <nz-switch [(ngModel)]="showAllPicked" nzCheckedChildren="Show All Stock"
                        nzUnCheckedChildren="Show Tyre Stock" class="ml-2"></nz-switch>
                </div>
                <div nz-col nzSpan="8" class="text-center">
                    <button nz-button nzType="primary" (click)="downloadExcel()"
                        [disabled]="stockComplete().length === 0">
                        <i nz-icon nzType="file-excel" nzTheme="outline"></i>Download
                    </button>
                </div>
            </div>
            <hr>
            <nz-table #completed [nzData]="stockComplete()" [nzFrontPagination]="false"
                [nzLoading]="isCompletedLoading">
                <thead>
                    <tr>
                        <th>Brand</th>
                        <th>Description</th>
                        <th>Units</th>
                        <th>Available SOH</th>
                        <th>Jobcard Number / <br> SF Reference</th>
                        <th>Salesman</th>
                        <th>Date</th>
                        <th>Customer Details</th>
                        <th>Comments</th>
                        <!-- <th></th> -->
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let item of completed.data | filter: '': []: 0: pageSize">
                        <td><img src="https://sftptyres.blob.core.windows.net/brands-images/brands/{{item.brandImage}}"
                                class="brandImage" alt="{{item.brand}}" nz-tooltip nzTooltipTitle="{{item.brand}}"
                                nzTooltipPlacement="right" /></td>
                        <td>{{item.description}}</td>
                        <td>{{item.qty}}</td>
                        <td>{{item.availableSOH}}</td>
                        <td>{{item.jobCardNumber}} <br> {{item.SFReference}}</td>
                        <td>{{item.assignedTo}}</td>
                        <td>{{item.dt + 'Z' | date:'dd MMM YYYY HH:mm'}}</td>
                        <td class="text-center">
                            <button nz-button (click)="selectItem(item)"><span nz-icon nzType="eye"
                                    nzTheme="outline"></span></button>
                        </td>
                        <td>{{item.comments ? item.comments : '-'}}</td>
                    </tr>
                </tbody>
            </nz-table>
        </ng-template>
    </nz-tab>
</nz-tabset>

<!-- Customer Details -->

<nz-modal [(nzVisible)]="isCustomerDetailsModalVisible" nzTitle="Customer Details"
    (nzOnCancel)="isCustomerDetailsModalVisible = false" (nzOnOk)="isCustomerDetailsModalVisible = false"
    [nzWidth]="800">
    <ng-container *nzModalContent>
        <nz-table #summary [nzData]="[selectedstoreRoomSummaryItem]" [nzFrontPagination]="false" [nzLoading]="isLoading"
            style="overflow-x: auto;">
            <thead>
                <tr>
                    <th>Customer</th>
                    <th>Vehicle Registration</th>
                    <th>Vehicle Vehicle Details</th>
                    <th>Qty</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let item of summary.data">
                    <td>{{item.customerName}}</td>
                    <td style="text-transform:uppercase;">{{item.vehicleReg}}</td>
                    <td><strong>{{item.vehicleMake}}</strong><span> / {{item.vehicleModel}}</span></td>
                    <td class="text-center">{{item.qty}}</td>
                </tr>
            </tbody>
        </nz-table>
    </ng-container>
</nz-modal>